// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementReportDashboardsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      created_by: string || null,
      developer_id: string,
      last_edited_by: string || null,
      last_edited_by_id: string,
      created_at: string,
      edited_at: string,
    })
  ),
});
